import { createSlice, current } from '@reduxjs/toolkit';

const initialState = {
  editedBy: '',
  emailDelivery: null,
  latestImportJob: null,
  latestSynchronizeJob: null,
  notificationEmails: [],
  productSettings: null,
  saveInProgress: false,
  serviceCenterSettings: null,
  synchronizes: null,
  isSettingsDirty: false,
};

export const guestRequestSettingsSlice = createSlice({
  name: 'guestRequestSettingsSlice',
  initialState,
  reducers: {
    setSaveInProgress(state, action) {
      state.saveInProgress = action.payload;
    },
    setSettings(state, action) {
      const {
        emailDelivery,
        latestImportJob,
        latestSynchronizeJob,
        productSettings,
        serviceCenterSettings,
        synchronizes,
      } = action.payload;
      state.emailDelivery = emailDelivery;
      state.latestImportJob = latestImportJob;
      state.latestSynchronizeJob = latestSynchronizeJob || {
        created: null,
        last_updated: null,
        status: null,
      };
      state.productSettings = productSettings;
      state.serviceCenterSettings = serviceCenterSettings;
      state.notificationEmails = serviceCenterSettings?.email_addresses || [];
      state.synchronizes = synchronizes;
      state.editedBy = `${latestImportJob?._edited_by.first_name || ''} ${
        latestImportJob?._edited_by.last_name || ''
      }`;
    },
    setLatestSynchronizeJob(state, action) {
      state.latestSynchronizeJob = action.payload;
    },
    addEmailAddress(state, action) {
      const { emails } = action.payload;
      const { notificationEmails } = current(state);
      state.notificationEmails = [...notificationEmails, ...emails];
    },
    removeEmailAddress(state, action) {
      const { email } = action.payload;
      const { notificationEmails } = current(state);
      const newNotificationEmails = [...notificationEmails].filter(
        (em) => em !== email,
      );
      state.notificationEmails = newNotificationEmails;
    },
    cleanGuestRequestSettingsSlice() {
      return initialState;
    },
    setIsSettingsDirty(state, action) {
      state.isSettingsDirty = action.payload;
    },
  },
});

export const {
  addEmailAddress,
  cleanGuestRequestSettingsSlice,
  removeEmailAddress,
  setLatestSynchronizeJob,
  setSaveInProgress,
  setSettings,
  setIsSettingsDirty,
} = guestRequestSettingsSlice.actions;

export default guestRequestSettingsSlice.reducer;
